<mat-slide-toggle
  [labelPosition]="labelPosition"
  color="primary"
  [checked]="isChecked"
  [disabled]="isDisabled"
  (change)="sliderHasChanged($event)"
>
  <ng-content></ng-content>
</mat-slide-toggle>
